import HotelCardHeaderLabel from './HotelCardHeaderLabel';

export default HotelCardHeaderLabel;
